const prefix = 'pds-link-button';

export const i18n = {
    navigateToPds: {
        id: `${prefix}.navigateToPds`,
        defaultMessage: 'Navigate to PDS',
    },
} as const;
